import { useEffect } from "react"
import { Alert } from "react-bootstrap"
import EqxButton from "../shared/components/EqxButton/EqxButton"
import EqxIcon from "../shared/components/EqxIcon"

interface PageMaintenanceProps {
    error?: string
}

const PageMaintenance = function (props: PageMaintenanceProps) {

    useEffect(() => {
        //change body class - remove any that start with page-* and add page-login
        document.body.className = document.body.className.replace(/\bpage-\S+/g, '')
        document.body.classList.add('page-login')

        return () => {
            document.body.className = document.body.className.replace(/\bpage-\S+/g, '')
        }
    }, [])

    const error = props.error ?? 'The application is currently undergoing maintenance. Please try again later.'

    return (
        <div id="login-container">
            <div id="login-outer-title">Continuum-BI</div>
            <div id="login">
                <div id="login-header">
                    <img src="/images/logo-no-text.svg" alt="Continuum-BI" id="login-logo" />
                    <img src="/images/logo-text.svg" alt="" id="login-logo-text" style={{ height: 20 }} />
                </div>
                <div id="login-body">
                    <div className="text-center" style={{ fontSize: 70, marginBottom: 20 }}>
                        <EqxIcon fa="fa-solid fa-wrench" className="text-secondary" />
                    </div>
                    <Alert variant="warning" className="text-start">
                        <strong>Maintenance</strong>
                        <div className="mt-2">{error}</div>
                    </Alert>

                    <EqxButton onClick={() => window.location.reload()} size="lg" variant="primary" id="login-button">
                        <span className="fas fa-redo me-2"></span>
                        Retry
                    </EqxButton>
                </div>
            </div>
        </div>
    )
}

export default PageMaintenance 